import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { MdAdd, IoMdCheckmarkCircle } from '../../Common/Icons';
import orgImage from '../../Assets/Img/org-image.jpg';
import {
  getCurrentOrganization,
  setCurrentOrganization,
} from '../../Helpers/CurrentSession';
import { imagePath, restRequest } from '../../Helpers/RequestHelper';
import { imagePathS3 } from '../../Helpers/RequestHelper';
import './SidePanel.css';
import {
  checkError,
  getOrganization,
  logout,
  setOrganization,
} from '../../Helpers/AuthHelper';
import Loader from '../Loader/Loader';
import WithContext from '../../Context/UserContextHOC';
import Toaster from '../../Helpers/Toaster/Toaster';
import { CustomModal } from '../../Components';
import GeneralModule from './GeneralModule';
import { ImageUrl } from '../../Helpers/ImageUrl';
import { t } from 'i18next';
import { IoMdLink } from 'react-icons/io';
import { FaLink } from 'react-icons/fa6';
import { ToolTip } from '../../Common';
// import "bootstrap/dist/css/bootstrap.min.css";

class SidePanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      organizations: [],
      loading: false,
      currentOrg: {},
      toastMessage: '',
      toastType: null,
      moduleSharingModal: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  componentDidMount() {
    // document.title = 'SidePanel'
    // const sidebar = localStorage.getItem('organizationSideBar');
    // if (sidebar) {
    //   this.fetchOrgData();
    // } else
    this.fetchData();
  }

  async fetchData() {
    this.setState({ loading: true });
    await restRequest('get', `organizations`)
      .then((res) => {
        let currentOrg = res.organizations.filter(
          (org) => org.organizations.id === getCurrentOrganization().id
        );
        this.setState({
          organizations: res.organizations,
          loading: false,
          currentOrg: currentOrg[0],
          orgLogo:
            currentOrg[0] && currentOrg[0].organizations.logo
              ? ImageUrl(currentOrg[0].organizations.logo)
              : imagePathS3(orgImage)
              ? orgImage
              : ImageUrl(orgImage),
          orgName: currentOrg[0] && currentOrg[0].organizations.name,
          orgEmail:
            currentOrg[0] && currentOrg[0].organizations.primary_contact_email,
        });
      })
      .catch((error) => {
        checkError(error);
      });
  }
  async fetchOrgData() {
    this.setState({ loading: true });
    await restRequest('get', `books_organizations`)
      .then((res) => {
        this.setState({
          organizations: res.organizations,
          loading: false,
        });
      })
      .catch((error) => {
        checkError(error);
      });
  }

  handleSwitchOrganization(organizationId, oranizationName, platform_type) {
    localStorage.removeItem('skipBtnoldAccount');
    localStorage.removeItem('skipBtnpress');
    let result = platform_type.split(',');
    if (result.includes('ims')) {
      this.setState({
        loading: true,
      });

      const currentOrganizationId = parseInt(getOrganization());
      const {
        context: { changeRole },
        // history,
      } = this.props;
      if (currentOrganizationId === organizationId) {
        this.setState({
          loading: false,
        });
        return;
      }

      restRequest('get', `organizations/${organizationId}`)
        .then((res) => {
          setOrganization(organizationId);

          localStorage.setItem('switch_org', JSON.stringify(true));
          localStorage.setItem('org_switch', true);
          restRequest('get', 'currentuser/role').then((role) => {
            changeRole(role);
            setOrganization(organizationId);
            setCurrentOrganization(res);
            window.location.href = '/dashboard';
            this.setState({
              loading: false,
            });
          });
        })
        .catch((error) => {
          checkError(error);
          this.setState({
            loading: false,
            toastMessage: error.response && error.response.data.message,
            toastType: 'error',
          });
          setTimeout(() => {
            this.setState({
              toastMessage: '',
              toastType: null,
            });
          }, 6000);
        });
    } else {
      this.setState({
        moduleSharingModal: true,
        organization_Id: organizationId,
        orgSwitchName: oranizationName,
      });
    }
  }

  handleSubmit(payload = '') {
    this.setState({ loading: true });
    restRequest('post', 'module_permissions', {
      organization_id: this.state?.organization_Id,
      modules: [...payload],
    }).then((res) => {
      if (res) {
        // let org_id = this.state.organization_Id;
        // this.setState({
        //   organization_Id: null,
        //   moduleSharingModal: false,
        // });
        this.handleSwitchOrganization(this.state?.organization_Id, '', 'ims');
        // window.location.reload();
      }

      localStorage.removeItem('organizationSideBar');
    });
    // .finally(() => {
    //   this.setState({ loading: false });
    // });
  }

  handleClose() {
    this.setState({ moduleSharingModal: false });
  }

  renderCreateModal = () => (
    <CustomModal
      showModal={this.state.moduleSharingModal}
      title="Organization Sharing"
      renderActions={false}
      size="small"
      onClose={this.handleClose}
    >
      <GeneralModule
        state={this.state}
        handleClose={this.handleClose}
        handleSubmit={this.handleSubmit}
      />
    </CustomModal>
  );

  render() {
    const { ssoConnected, redirect_to_payment_page } = this.props;
    return (
      <>
        {this.state.moduleSharingModal && this.renderCreateModal()}
        {this.state.toastMessage !== '' && (
          <Toaster
            message={this.state.toastMessage}
            type={this.state.toastType}
          />
        )}
        {/* <div className={`${this.props.showSidePanel ? "sidenav-overlay sidenav-overlayshow" : "sidenav-overlay"}`}></div> */}
        {/* <div class="sidenav-overlay"></div> */}
        <div
          id="sidep"
          className={`sidepanel sidebar-mob ${
            this.props.showSidePanel ? 'panelshow' : 'panelhide'
          }`}
        >
          <div className="intro-orginization">
            <div className="image">
              {this.state.loading ? (
                <Loader />
              ) : (
                <div className="image_circle">
                  <img src={this.state.orgLogo} alt="Organization pic"></img>
                </div>
              )}
            </div>
            <div className="name">{this.state.orgName}</div>
            <div className="user-email">{this.state.orgEmail}</div>
            <ul>
              {ssoConnected ? (
                <li>
                  <button
                    onClick={(e) => {
                      if (redirect_to_payment_page) {
                        e.preventDefault();
                        return;
                      } else {
                        window.open(
                          `${process.env.REACT_APP_SSO_REDIRECT_DEV}/myProfile`
                        );
                        this.props.closeMe();
                      }
                    }}
                  >
                    {t('common.my_account')}
                  </button>
                </li>
              ) : (
                <li>
                  <button
                    onClick={(e) => {
                      if (redirect_to_payment_page) {
                        e.preventDefault();
                        return;
                      } else {
                        this.props.history.push('/myaccount');
                        this.props.closeMe();
                      }
                    }}
                  >
                    {t('common.my_account')}
                  </button>
                </li>
              )}

              <li>
                <button id="click_signout_button" onClick={() => logout()}>
                  {t('common.sign_out')}
                </button>
              </li>
            </ul>
          </div>
          {this.state.loading ? (
            <Loader />
          ) : (
            <ul className="oganization-list">
              <li
                onClick={() => this.props.closeMe()}
                style={{ cursor: 'text' }}
              >
                {t('common.my_business')}
                <Link to={redirect_to_payment_page ? '#' : '/organization/add'}>
                  <span title={t('common.add_business')}>
                    <MdAdd className="add-organziation" />{' '}
                  </span>
                </Link>
              </li>
              {this.state.organizations?.map((org, index) => {
                return (
                  <li
                    className={` display-flex ${
                      getCurrentOrganization()?.id === org.organizations?.id // && !Object.keys(this.state.currentOrg)
                        ? 'active'
                        : ''
                    }`}
                    onClick={(e) => {
                      if (redirect_to_payment_page) {
                        e.preventDefault();
                        return;
                      } else {
                        this.handleSwitchOrganization(
                          org.organization_id,
                          org.organizations.name ?? org.name,
                          org?.platform_type
                        );
                      }
                    }}
                    key={index}
                  >
                    <div className="org-name">
                      {org.organizations ? org.organizations.name : org.name}
                      <div className="small-sidepanel">{`${t(
                        'saleOrder.package'
                      )} : ${
                        org?.organizations?.organization_plan
                          ? org?.organizations?.organization_plan.name?.split(
                              ' '
                            )[0]
                          : t('common.free')
                      } `}</div>
                    </div>
                    {org.organizations.created_by_platform !== 'ims' && (
                      <div className="circle_align">
                        {org.platform_type !== 'ims' && (
                          <span
                            className="share-icon"
                            // className={
                            //   org.platform_type !== 'books'
                            //     ? 'owner-label'
                            //     : 'invited-label'
                            // }
                            style={
                              org.platform_type === 'books'
                                ? { color: '#f09797' }
                                : { color: '#306ab4' }
                            }
                          >
                            {org.platform_type === 'books' ? (
                              <ToolTip
                                content={t(
                                  'common.share_your_business_with_bms'
                                )}
                              >
                                <IoMdLink />
                              </ToolTip>
                            ) : (
                              <ToolTip
                                content={t(
                                  'common.business_is_shared_with_bms'
                                )}
                              >
                                <FaLink />
                              </ToolTip>
                            )}
                          </span>
                        )}
                      </div>
                    )}
                    <div className="circle_align">
                      <span
                        className={
                          org.role_id === 1 ? 'owner-label' : 'invited-label'
                        }
                      >
                        {org.role_id === 1
                          ? t('common.owner')
                          : t('common.invited')}
                      </span>{' '}
                      {/* {org.platform_type !== 'ims' && (
                        <span
                          className={
                            org.platform_type !== 'books'
                              ? 'owner-label'
                              : 'invited-label'
                          }
                          style={
                            org.platform_type === 'books'
                              ? { background: '#f09797' }
                              : {}
                          }
                        >
                          {org.platform_type === 'books'
                            ? 'Unshared*'
                            : 'Shared*'}
                        </span>
                      )} */}
                      <IoMdCheckmarkCircle className="checkcircle" />
                    </div>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </>
    );
  }
}
export default WithContext(SidePanel);
